import type { CustomIconProps } from '../types';

const Union = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '14'}
        height={height ?? '16'}
        viewBox="0 0 14 16"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 6.4C0 11.2 7 16 7 16C7 16 14 11.2 14 6.4C14 2.4 10.5 0 7 0C3.5 0 0 2.4 0 6.4ZM7 14.3397C6.91813 14.276 6.83096 14.2073 6.73918 14.1338C6.11273 13.6327 5.28191 12.9201 4.45599 12.0706C3.62611 11.217 2.8289 10.2534 2.24546 9.25317C1.65819 8.24644 1.33333 7.28137 1.33333 6.4C1.33333 3.34728 4.00608 1.33333 7 1.33333C9.99392 1.33333 12.6667 3.34728 12.6667 6.4C12.6667 7.28137 12.3418 8.24644 11.7545 9.25317C11.1711 10.2534 10.3739 11.217 9.54401 12.0706C8.71809 12.9201 7.88727 13.6327 7.26082 14.1338C7.16904 14.2073 7.08187 14.276 7 14.3397ZM8.17851 7.17851C7.86595 7.49107 7.44202 7.66667 7 7.66667C6.55797 7.66667 6.13405 7.49107 5.82149 7.17851C5.50893 6.86595 5.33333 6.44203 5.33333 6C5.33333 5.55797 5.50893 5.13405 5.82149 4.82149C6.13405 4.50893 6.55797 4.33333 7 4.33333C7.44203 4.33333 7.86595 4.50893 8.17851 4.82149C8.49107 5.13405 8.66667 5.55797 8.66667 6C8.66667 6.44203 8.49107 6.86595 8.17851 7.17851ZM7 9C7.79565 9 8.55871 8.68393 9.12132 8.12132C9.68393 7.55871 10 6.79565 10 6C10 5.20435 9.68393 4.44129 9.12132 3.87868C8.55871 3.31607 7.79565 3 7 3C6.20435 3 5.44129 3.31607 4.87868 3.87868C4.31607 4.44129 4 5.20435 4 6C4 6.79565 4.31607 7.55871 4.87868 8.12132C5.44129 8.68393 6.20435 9 7 9Z"
            fill="#1A1A1A"
        />
    </svg>
);

export default Union;
